import React from 'react';
import PropTypes from 'prop-types';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';

const Layout = (props) => {
  return(
    <div className="EventSubmissionApp">
      {props.children}
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
};

export default Layout;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/layout/Layout.jsx